import React from 'react';
import styled from 'styled-components';
import CheckboxToggle from '../../../shared/toggle/CheckboxToggle';

type iAttribute = {
  title: string;
  description?: string;
  name: string;
  isChecked?: boolean;
};
const TogglesWrapper = styled.div`
  margin-top: 1rem;
  .not-first-child {
    margin-top: 0.8rem;
  }
`;
const DetailToggles = ({
  attributes,
  onToggle,
  isDisabled,
}: {
  attributes: Array<iAttribute>;
  onToggle: (name: string, value: boolean) => void;
  isDisabled?: boolean;
}) => {
  return (
    <TogglesWrapper>
      {attributes.map((a: iAttribute, index: number) => (
        <CheckboxToggle
          attribute={a}
          key={a.name}
          onToggle={onToggle}
          className={index !== 0 ? 'not-first-child' : undefined}
          isDisabled={isDisabled}
        />
      ))}
    </TogglesWrapper>
  );
};

export default DetailToggles;
